import React from 'react';

import { createRoot } from 'react-dom/client';

import WebFont from 'webfontloader';

import App from './App';
import './index.css';
import {
  checkPayment,
  fastspringOrder,
} from './components/pages/PricingPage/PricingPageContent/PricingPageService';

const rootElement = document.getElementById('root');
const root = createRoot(rootElement);
root.render(<App />, rootElement);

WebFont.load({
  custom: {
    families: ['Inter'],
    urls: ['/fonts/inter.css'],
  }
})

window.onWebhookReceived = (res) => {
  if (res && res.tags) {
    fastspringOrder(res.id);
    let userId = res.tags['user_id'];
    let checkPaymentTimer = setInterval(() => {
      checkPayment(userId);
    }, 1000);

    // if we didnt get redirect in checkPayment for 2 minutes - stop send request
    setTimeout(() => { clearInterval(checkPaymentTimer) }, 1000 * 60 * 2);
  }
}